// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/receipt/stylesheets/refill.scss
 ** module id = 460
 ** module chunks = 1
 **/